/**
 * Single-key shortcuts (`?`, `/`, later H, M, D in W3) must not fire while
 * the user types (WCAG 2.1.4, DES-3): true when the event comes from a text
 * field, a select or an editable element.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!target || typeof (target as HTMLElement).tagName !== 'string') return false;
  const el = target as HTMLElement;
  const tag = el.tagName.toLowerCase();
  if (tag === 'textarea' || tag === 'select') return true;
  if (tag === 'input') {
    const type = ((el as HTMLInputElement).type || 'text').toLowerCase();
    return !['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file', 'image'].includes(type);
  }
  return el.isContentEditable === true;
}
